import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollText } from 'lucide-react';

const TermsPage = () => (
  <div className="min-h-screen bg-slate-50 py-16 px-4">
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <ScrollText className="w-7 h-7 text-blue-600" />
        <h1 className="text-2xl font-bold text-slate-900">Conditions générales de vente</h1>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-8 space-y-6 text-sm text-slate-600 leading-relaxed">
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Objet</h2>
          <p>Les présentes CGV régissent l'utilisation du service LoyalPass, plateforme de gestion de cartes de fidélité digitales.</p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Essai gratuit</h2>
          <p>Chaque nouveau compte bénéficie d'un essai gratuit de 14 jours, sans carte bancaire requise. À l'issue de l'essai, un abonnement payant est nécessaire pour continuer à utiliser le service.</p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Abonnements</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li><strong>Essentiel</strong> — 29€/mois HT</li>
            <li><strong>Pro</strong> — 59€/mois HT</li>
          </ul>
          <p className="mt-2">Les abonnements sont mensuels, sans engagement. La résiliation prend effet à la fin de la période en cours.</p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Droit de rétractation</h2>
          <p>Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux services pleinement exécutés avant la fin du délai de rétractation.</p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Contact</h2>
          <p><a href="mailto:contact@getloyalpass.fr" className="text-blue-600 underline">contact@getloyalpass.fr</a></p>
        </section>
        <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">Dernière mise à jour : 2 juillet 2026</p>
      </div>
      <div className="text-center mt-6">
        <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 underline">Retour à l'accueil</Link>
      </div>
    </div>
  </div>
);

export default TermsPage;
